import PropTypes from 'prop-types';
import { useAuth } from 'contexts/AuthContext';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LockOutlined from '@mui/icons-material/LockOutlined';

export default function RoleGuard({ roles, children }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!roles.includes(user?.role)) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          gap: 2
        }}
      >
        <LockOutlined sx={{ fontSize: 64, color: 'text.secondary' }} />
        <Typography variant="h4">Access Denied</Typography>
        <Typography variant="body1" color="text.secondary">
          You do not have permission to access this page.
        </Typography>
        <Button variant="contained" onClick={() => navigate('/dashboard/default')}>
          Go to Dashboard
        </Button>
      </Box>
    );
  }

  return children;
}

RoleGuard.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired
};
